import { Component, OnInit } from '@angular/core';
import { Globals } from '../../globals';
import { ProductoService } from '../../servicios/producto.service'
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-filtro-tags',
  templateUrl: './modal-filtro-tags.component.html',
  styleUrls: ['./modal-filtro-tags.component.scss']
})
export class ModalFiltroTagsComponent implements OnInit {

  tagsField = "";

  tags = {
    cargando: false,
    registros: new Array()
  };

  constructor(
    public globals: Globals,
    private productoService: ProductoService,
    public dialogRef: MatDialogRef<ModalFiltroTagsComponent>,
  ) { }

  cargarTags(){
    this.productoService.tagsListado({
      categoria: this.globals.configuracion.front.listado.categoria
    }).subscribe(
      resultado =>{
        if( !resultado.error ){
          Array.prototype.push.apply( this.tags.registros, resultado.registros );
          this.tags.cargando = false;
        }else{
          console.log("Error",resultado.mensaje);
        }

      },
      error =>{
        console.log("Error",error);
        //this.feedProductos.cargando = false;
      }
    )
  }

  aceptarTags(){
    let modeloSelect = {
      idmodelo: "",
      marca_modelo: ""
    }
    if( this.tagsField != '' ){
      let itemSearch = this.tags.registros.find( tag => tag.idmodelo == this.tagsField );
      if( itemSearch != undefined ){
        modeloSelect.idmodelo = itemSearch.idmodelo;
        modeloSelect.marca_modelo = itemSearch.marca_modelo;
      }
    }
    this.dialogRef.close( modeloSelect );
  }

  ngOnInit(): void {
    this.tagsField = this.globals.configuracion.front.listado.tag;
    this.cargarTags();
  }

}
